<script>
import FinishDialog from "@/views/trips/components/dialogs/FinishDialog.vue";

export default {
  name: "FinishAction",
  components: { FinishDialog },
  inheritAttrs: false,
  props: {
    trip: Object,
    route: Object,
    stop: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["finish", "update:modelValue"],
  data() {
    return {
      showDialog: false,
    };
  },
  methods: {
    showFinishDialog() {
      this.showDialog = true;
    },
  },
};
</script>

<template>
  <v-btn
    :disabled="disabled"
    block
    class="text-uppercase font-weight-600"
    color="primary"
    v-bind="$attrs"
    variant="flat"
    @click="showFinishDialog"
  >
    Finish
  </v-btn>
  <finish-dialog
    v-model="showDialog"
    :stop="stop"
    :trip-id="trip.id"
    :truck-id="route.truckId"
    @finish="$emit('finish')"
  />
</template>

<style lang="scss" scoped></style>
